function Error({ error }: any) {
  return (
    <>
      {`An Error Occurred: ${error?.errorCode}`}
    </>
  );
}

export default Error;